import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Switch, Route } from 'react-router-dom';
import { get, omit } from 'lodash';
import { useLocation, withRouter } from 'react-router';

import {
    setSignUpBasicData,
    signUpAttempt,
    trackEvent as trackEventAction,
} from '../store/signup/signupAction';
import Footer from '../components/Footer';
import Header from '../components/Header';
import StepNavigation from '../components/StepNavigation';
import { setStepNumber } from '../store/signup/signupAction';
import ChoosePlan from './choosePlan/ChoosePlan';
import DomainDetails from './domainDetails/DomainDetails';
import GetDomain from './getDomain/GetDomain';
import Payment from './payment/Payment';
import Validate from './validate/Validate';
import SignUp from './signUp/SignUp';
import Loader from '../components/Loader';
import ScrollToTop from '../components/ScrollToTop';
import SharpSpringScriptLoader from './freeTrial/SharpSpringScriptLoader';

/**
 * signup submit function
 * @param {*} data
 * @param {*} history
 * @param {*} signUpAttempt
 * @param {*} setSignUpBasicData
 * @param {*} setStepNumber
 * @param {*} setShowLoader
 * @param {*} needDomain
 * @param {*} needMailServer
 */
const signupSubmit = (
    data,
    history,
    signUpAttempt,
    setSignUpBasicData,
    setStepNumber,
    setShowLoader,
    needDomain,
    needMailServer,
    trackEvent
) => {
    setShowLoader(true);
    const submitData = {
        ...data,
        need_domain: needDomain,
        need_mail: needDomain ? true : needMailServer,
    };

    signUpAttempt(submitData).then((res) => {
        setShowLoader(false);
        if (res.status === 'success') {
            setSignUpBasicData(res.data);
            trackEvent(process.env.REACT_APP_TRACKER_NORMAL_SIGNUP_STEP_1_ENDPOINT_ID, {
                ...omit(submitData, ['captcharesponse']),
                formId: get(res.data, 'form_id', '')
            });
            setStepNumber(2);
            history.push('/registration/validate');
        }
    });
};
/**
 * Wizard page component
 * @param {*} param0
 */
const WizardPage = ({
    setStepNumber,
    currentStep,
    signUpAttempt,
    trackEvent,
    setSignUpBasicData,
    needDomain,
    needMailServer,
    history,
}) => {
    const history1 = useHistory();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    window.dataLayer.push({
        event: 'pageview',
        page: {
            url: document.location.pathname,
            title: ''
        }
    });
    useEffect(() => {
        if (location.pathname !== '/registration') {
            window.addEventListener('popstate', () => {
                // history.go(1);

                window.history.go(1);
            });
        }
    });
    return (
        <>
            <div className="container">
                <SharpSpringScriptLoader/>
                <Header />
                <StepNavigation />
                <ScrollToTop />
                {showLoader && <Loader />}
                <Switch>
                    <Route
                        exact
                        path="/registration"
                        render={() => (
                            <SignUp
                                submit={(data) =>
                                    signupSubmit(
                                        data,
                                        history1,
                                        signUpAttempt,
                                        setSignUpBasicData,
                                        setStepNumber,
                                        setShowLoader,
                                        needDomain,
                                        needMailServer,
                                        trackEvent
                                    )
                                }
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/registration/validate"
                        render={() => <Validate />}
                    />
                    <Route
                        exact
                        path="/registration/get-domain"
                        render={() => <GetDomain />}
                    />
                    <Route
                        exact
                        path="/registration/choose-plan"
                        render={() => <ChoosePlan />}
                    />
                    <Route
                        exact
                        path="/registration/domain-details"
                        render={() => <DomainDetails />}
                    />
                    <Route
                        exact
                        path="/registration/payment"
                        render={() => <Payment />}
                    />
                </Switch>
            </div>
            <Footer currentStep={currentStep} setShowLoader={setShowLoader} />
        </>
    );
};

const mapStateToProps = (store) => ({
    currentStep: store.signupReducer.currentStep,
    needDomain: get(store, 'signupReducer.needDomain', null),
    needMailServer: get(store, 'signupReducer.needMailServer', null),
});
const mapDispatchToProps = {
    setStepNumber,
    signUpAttempt,
    trackEvent: trackEventAction,
    setSignUpBasicData,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(WizardPage));
// export default Wizard;
